import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { environment } from "environments/environment";

@Injectable()
export class VitalSignSpecialityService {

    constructor(private _http: HttpClient) { }

    get = (): Observable<any[]> => {
        return this._http.get<any>(`${environment.core}VitalSignSpeciality`);
    }

    post = (data: any): Observable<any> => {
        return this._http.post<any>(`${environment.core}VitalSignSpeciality`, data);
    }

    update = (data: any): Observable<any> => {
        return this._http.put<any>(`${environment.core}VitalSignSpeciality`, data);
    }

    delete = (id: any): Observable<any> => {
        return this._http.delete<any>(`${environment.core}VitalSignSpeciality?id=${id}`);
    }
}